/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Forward_An_EmailInputs */

const en_common_forward_an_email = /** @type {(inputs: Common_Forward_An_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward an email`)
};

const es_common_forward_an_email = /** @type {(inputs: Common_Forward_An_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar un correo`)
};

/**
* | output |
* | --- |
* | "Forward an email" |
*
* @param {Common_Forward_An_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_forward_an_email = /** @type {((inputs?: Common_Forward_An_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Forward_An_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_forward_an_email(inputs)
	return en_common_forward_an_email(inputs)
});